import { getFromServerTopic } from "@utility/slice";
import { createSlice } from "@reduxjs/toolkit";

// TODO: Change this to "buildings" once the existing topic/buildings is cleaned up.
const SLICE = "sitesAndLocations";

// const action = (name) => `${SLICE}/${name}`;

export const getFromServer = (action, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, payloadFn });

export const getActiveBuildingsByUserAccess = getFromServer(
  "getActiveBuildingsByUserAccess",
);

export const slice = createSlice({
  name: SLICE,
  initialState: {
    buildings: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getActiveBuildingsByUserAccess.fulfilled,
      (state, action) => {
        state.buildings = action.payload.response;
      },
    );
  },
});

export default slice.reducer;
